import { render, staticRenderFns } from "./DepartmentTemplate.vue?vue&type=template&id=0bcf35d8"
import script from "./DepartmentTemplate.vue?vue&type=script&lang=js"
export * from "./DepartmentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports